import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/stockist/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Stockist',
    meta: {
      title: 'Common.menu.stockist_management',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.stockist,
      icon: 'home_work',
    },
    children: [
      {
        path: MODULE_PATH + 'list',
        component: load('application/stockist/components/StockistList'),
        name: 'Stockist List',
        meta: {
          title: 'Common.menu.stockist_setup',
          icon: 'attach_money',
          menuItem: true,
          sorting: 701,
        },
      },
      {
        path: MODULE_PATH + 'registration',
        component: load('application/stockist/components/StockistRegistrationArea'),
        name: 'Stockist Registration',
        meta: {
          title: 'Common.menu.stockist_setup',
          icon: 'attach_money',
          menuItem: false,
          sorting: 702,
        },
      },
      {
        path: MODULE_PATH + 'funds/list',
        component: load('application/stockist/components/StockistConsignmentDepositList'),
        name: 'Stockist Consignment Funds',
        meta: {
          title: 'Common.menu.stockist_funds',
          icon: 'attach_money',
          menuItem: true,
          sorting: 703,
        },
      },
      {
        path: MODULE_PATH + 'funds/[:depositRefundType]/new',
        component: load('application/stockist/components/StockistConsignmentDepositArea'),
        name: 'New Stockist Consignment Deposit',
        props: true,
        meta: {
          title: 'Common.menu.stockist_deposit',
          icon: 'attach_money',
          menuItem: false,
          sorting: 704,
        },
      },
      {
        path: MODULE_PATH + 'funds/[:depositRefundType]/detail/[:depositRefundID]',
        component: load('application/stockist/components/StockistConsignmentDepositArea'),
        name: 'Stockist Consignment Deposit Area',
        props: true,
        meta: {
          title: 'Common.menu.stockist_deposit',
          icon: 'attach_money',
          menuItem: false,
          sorting: 705,
        },
      },
      {
        path: MODULE_PATH + 'funds/[:depositRefundType]/new',
        component: load('application/stockist/components/StockistConsignmentDepositArea'),
        name: 'New Stockist Consignment Refund',
        props: true,
        meta: {
          title: 'Common.menu.stockist_deposit',
          icon: 'attach_money',
          menuItem: false,
          sorting: 706,
        },
      },
      {
        path: MODULE_PATH + 'funds/[:depositRefundType]/detail/[:depositRefundID]',
        component: load('application/stockist/components/StockistConsignmentDepositArea'),
        name: 'Stockist Consignment Refund Area',
        props: true,
        meta: {
          title: 'Common.menu.stockist_deposit',
          icon: 'attach_money',
          menuItem: false,
          sorting: 708,
        },
      },
      {
        path: MODULE_PATH + 'consignment/orders/sales/list',
        component: load('application/stockist/components/StockistConsignmentList'),
        name: 'Stockist Consignment Order List',
        meta: {
          title: 'Common.menu.stockist_consignment_order',
          icon: 'attach_money',
          menuItem: true,
          sorting: 709,
          type: 'order',
        },
      },
      {
        path: MODULE_PATH + 'consignment/orders/sales/detail/[:consignmentType]/[:consignmentID]',
        component: load('application/stockist/components/StockistConsignmentOrderAndReturnArea'),
        name: 'Stockist Consignment Order Area',
        props: true,
        meta: {
          title: 'Common.menu.stockist_consignment_order_area',
          icon: 'attach_money',
          menuItem: false,
          sorting: 710,
        },
      },
      {
        path: MODULE_PATH + 'consignment/orders/sales/new/[:consignmentType]',
        component: load('application/stockist/components/StockistConsignmentOrderAndReturnArea'),
        name: 'New Stockist Consignment Order',
        props: true,
        meta: {
          title: 'Common.menu.stockist_new_consignment_order',
          icon: 'attach_money',
          menuItem: false,
          sorting: 711,
        },
      },
      {
        path: MODULE_PATH + 'consignment/orders/return/list',
        component: load('application/stockist/components/StockistConsignmentList'),
        name: 'Stockist Consignment Return List',
        meta: {
          title: 'Common.menu.stockist_consignment_return_list',
          icon: 'attach_money',
          menuItem: true,
          sorting: 712,
          type: 'return',
        },
      },
      {
        path: MODULE_PATH + 'consignment/orders/return/detail/[:consignmentType]/[:consignmentID]',
        component: load('application/stockist/components/StockistConsignmentOrderAndReturnArea'),
        name: 'Stockist Consignment Return Area',
        props: true,
        meta: {
          title: 'Common.menu.stockist_consignment_return_detail',
          icon: 'attach_money',
          menuItem: false,
          sorting: 713,
        },
      },
      {
        path: MODULE_PATH + 'consignment/orders/return/[:consignmentType]/new',
        component: load('application/stockist/components/StockistConsignmentOrderAndReturnArea'),
        name: 'New Stockist Consignment Return',
        props: true,
        meta: {
          title: 'Common.menu.stockist_new_consignment_return',
          icon: 'attach_money',
          menuItem: false,
          sorting: 714,
        },
      },
      {
        path: MODULE_PATH + 'consignment/stock/report',
        component: load('application/stockist/components/StockistConsignmentStockReport'),
        name: 'Stockist Consignment Stock Report',
        meta: {
          title: 'Common.menu.stockist_consignment_stock_report',
          icon: 'attach_money',
          menuItem: true,
          sorting: 715,
        },
      },
      {
        path: MODULE_PATH + 'transactions/list',
        component: load('application/stockist/components/StockistDailyTransactionList'),
        name: 'Stockist Stock Replenishment',
        meta: {
          title: 'Common.menu.stockist_daily_transaction',
          icon: 'attach_money',
          menuItem: true,
          sorting: 716,
        },
      },
      {
        path: MODULE_PATH + 'transactions/list/[:stockistID]',
        component: load('application/stockist/components/StockistDailyTransactionList'),
        name: 'Stockist Daily Transaction List',
        props: true,
        meta: {
          title: 'Common.menu.stockist_daily_transaction',
          icon: 'attach_money',
          menuItem: false,
          sorting: 717,
        },
      },
      {
        path: MODULE_PATH + 'payment/verification',
        component: load('application/stockist/components/StockistPaymentVerification'),
        name: 'Stockist Payment Verification',
        meta: {
          title: 'Common.menu.stockist_payment_verification',
          icon: 'attach_money',
          menuItem: true,
          sorting: 718,
        },
      },
      {
        path: MODULE_PATH + 'collection/daily/report',
        component: load('application/stockist/components/StockistDailyCollectionReport'),
        name: 'Daily Collection Report',
        meta: {
          title: 'Common.menu.stockist_daily_collection_report',
          icon: 'attach_money',
          menuItem: true,
          sorting: 719,
        },
      },
      {
        path: MODULE_PATH + 'view/[:stockistUserID]',
        component: load('application/stockist/components/StockistRegistrationArea'),
        name: 'Stockist Update',
        props: true,
        meta: {
          title: 'Common.menu.stockist_setup',
          icon: 'attach_money',
          menuItem: false,
          sorting: 720,
        },
      },
    ],
  },
]
